import React, { useState } from 'react';

/**
 * 5-star rating widget.
 * - `value`     current selected value (0..5)
 * - `onChange`  called with chosen integer when the user clicks a star
 * - `readOnly`  if true, no hover/click behavior
 * - `size`      pixel size of each star (default 28)
 */
export default function RatingStars({ value = 0, onChange, readOnly = false, size = 28 }) {
  const [hover, setHover] = useState(0);
  const display = readOnly ? value : (hover || value);
  const stars = [1, 2, 3, 4, 5];

  return (
    <div
      className={`rating-stars ${readOnly ? 'is-readonly' : ''}`}
      role={readOnly ? 'img' : 'radiogroup'}
      aria-label={readOnly ? `Rating: ${value} of 5` : 'Choose a rating'}
      onMouseLeave={() => !readOnly && setHover(0)}
    >
      {stars.map((n) => {
        const filled = n <= display;
        return (
          <button
            key={n}
            type="button"
            role={readOnly ? undefined : 'radio'}
            aria-checked={!readOnly && value === n ? 'true' : 'false'}
            aria-label={`${n} star${n === 1 ? '' : 's'}`}
            className={`rating-star ${filled ? 'is-filled' : 'is-empty'}`}
            style={{ fontSize: size }}
            disabled={readOnly}
            onMouseEnter={() => !readOnly && setHover(n)}
            onFocus={() => !readOnly && setHover(n)}
            onBlur={() => !readOnly && setHover(0)}
            onClick={() => !readOnly && onChange?.(n)}
          >
            {filled ? '★' : '☆'}
          </button>
        );
      })}
    </div>
  );
}
